import { createAction } from 'redux-act';

export const applyToFacilitate = createAction();
export const receivedResponseOnApplyToFacilitate = createAction();
export const cleanApplyToFacilitate = createAction();

export const getLatestApplicationEmployer = createAction();
export const receivedLatestApplicationEmployer = createAction();
export const getLatestApplicationEmployerError = createAction();

export const getCorporatePartnersList = createAction();
export const receivedCorporatePartnersList = createAction();
export const getCorporatePartnersListError = createAction();
